"use strict";

var _slicedToArray = require("/codebuild/output/src355747095/src/gravitywell-website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebounce = void 0;

var react_1 = __importDefault(require("react"));
/**
 * Use debounce hook
 */


var useDebounce = function useDebounce(value, delay) {
  var _react_1$default$useS = react_1.default.useState(value),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      debouncedValue = _react_1$default$useS2[0],
      setDebouncedValue = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    // Update debounced value after delay
    // if timeout cleared before callback triggered, value not updated
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Re-running the effect clears the previous timeout and starts a new one

    return function () {
      clearTimeout(handler);
    }; // Only re-run effect if value or delay changes
  }, [value, delay]);
  return debouncedValue;
};

exports.useDebounce = useDebounce;